<template>
  <div class="list-container">
    <h1>相対湿度マトリクス</h1>

    <!-- Button trigger modal -->
    <button v-if="isAdmin" type="button" class="btn btn-primary" @click="downloadCsv">
      CSVエクスポート
    </button>

    <button v-if="isAdmin" type="button" class="btn btn-primary mx-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
      CSVインポート
    </button>

    <!-- Modal -->
    <div v-if="isAdmin" class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">CSVインポート</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearErrorMessages"></button>
          </div>
          <div class="modal-body">
            <div v-if="errorMessages" >
              <div class="error-massage-item" v-for="errorMessage in errorMessages" :key="errorMessage.id">
                <p class="alert alert-danger mt-2">{{ errorMessage.row_num }}行目：{{errorMessage.messages[0]}}</p>
              </div>
            </div>

            <div class="my-3">
              <p>相対湿度マトリクスCSVファイル選択</p>
              <input type="file" class="form-control" @change="handleFileChange">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearErrorMessages">閉じる</button>
            <button type="button" class="btn btn-primary" @click="submitFile">インポート</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="grouped_relative_humidity_matrixs[0]">
      <div class="table_box my-3">
        <table class="table table-bordered table-light">
          <tr>
            <th class="sticky_cross" rowspan="2">湿球<br>(℃)</th>
            <th class="sticky_col first_col" colspan="151">乾球と湿球との差 t - ｔ` (deg)</th>
          </tr>
          <tr>
            <!-- <th class="sticky_col"></th> -->
            <template class="relative_humidity_matrix-item" v-for="relative_humidity_matrix in grouped_relative_humidity_matrixs[0]" :key="relative_humidity_matrix.id">
              <th class="sticky_col second_col">{{relative_humidity_matrix.dry_wet_diff}}</th>
            </template>
          </tr>
          <template class="relative_humidity_matrix-item" v-for="relative_humidity_matrixs in grouped_relative_humidity_matrixs" :key="relative_humidity_matrixs.id">
            <tr>
              <!-- <th>{{relative_humidity_matrixs[0].line_no}}</th> -->
              <th class="sticky_row">{{relative_humidity_matrixs[0].wet_blub}}</th>
              <template class="relative_humidity_matrix-item" v-for="relative_humidity_matrix in relative_humidity_matrixs" :key="relative_humidity_matrix.id">
                <td>{{relative_humidity_matrix.relative_humidity}}</td>
              </template>
            </tr>
          </template>
        </table>
      </div>
    </div>
    <div v-else class="card m auto shadow-lg">
      <div class="card-body text-center">相対湿度マトリクスを読み込み中...</div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect, computed } from 'vue';
import { useStore } from 'vuex';
import { getRelativeHumidityMatrixs, importRelativeHumidityMatrixsCsv, exportRelativeHumidityMatrixsCsv } from '@/api/axios';
import { Modal } from 'bootstrap';
import { currentRoleFromStoreOrLocalStorage, isAdminRole } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('相対湿度マトリクス');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const isAdmin = computed(() => isAdminRole(currentRoleFromStoreOrLocalStorage(store.state.userRole)));
    const grouped_relative_humidity_matrixs = ref([]);
    const selectedFile = ref(null);

     // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const groupRelativeHumidityMatrixsByLineNo = (relative_humidity_matrixs) => {
      const grouped = relative_humidity_matrixs.reduce((acc, relative_humidity_matrix) => {
        const key = relative_humidity_matrix.line_no;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(relative_humidity_matrix);
        return acc;
      }, {});
      return Object.values(grouped);
    };

    const fetchMeasureTypes = async () => {
      try {
        const response = await getRelativeHumidityMatrixs();
        grouped_relative_humidity_matrixs.value = groupRelativeHumidityMatrixsByLineNo(response.data);
      } catch (error) {
        console.error('測定種別情報ーデータの取得に失敗しました:', error);
      }
    };

    // CSVインポート
    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0]; // 選択されたファイルを保存
    };

    // モーダルを閉じる処理
    const closeModal = () => {
      const modalElement = document.getElementById('exampleModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    // モーダルが閉じた後に実行される処理
    const onModalHidden = () => {
      clearErrorMessages(); // エラーメッセージをクリアする関数を呼び出す
    };

    // モーダルの閉じるボタンのアクション
    const clearErrorMessages = () => {
      errorMessages.value = {}; // エラーメッセージをクリア
      selectedFile.value = null; // ファイルをクリア

      // inputタグのvalueをリセット
      const input = document.querySelector('.form-control[type="file"]');
      if (input) {
        input.value = '';
      }
    };

    const submitFile = async () => {
      if (!selectedFile.value) {
        store.commit('setFlashMessage', { message: 'ファイルが選択されていません', type: 'danger' });
        return;
      }

      try {
        await importRelativeHumidityMatrixsCsv(selectedFile.value); // 選択されたファイルを関数に渡す
        store.commit('setFlashMessage', { message: 'アップロードに成功しました', type: 'success' });
        // モーダルを閉じる
        closeModal();

        // モーダルが完全に閉じた後に実行されるイベントリスナーを追加
        document.getElementById('exampleModal').addEventListener('hidden.bs.modal', onModalHidden, { once: true });

        // 顧客情報の再取得
        await fetchMeasureTypes();
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        console.error('アップロードに失敗しました', error);
        store.commit('setFlashMessage', { message: 'アップロードに失敗しました', type: 'danger' });
      }
    };

    const downloadCsv = async () => {
      try {
        const response = await exportRelativeHumidityMatrixsCsv();
        const now = new Date();
        const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;
        const fileName = `m_relative_humidity_matrixs_${timestamp}.csv`;

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('CSVダウンロードエラー', error);
        store.commit('setFlashMessage', { message: 'CSVダウンロードに失敗しました', type: 'danger' });
      }
    };

    onMounted(fetchMeasureTypes);

    return {
      title,
      isAdmin,
      grouped_relative_humidity_matrixs,
      selectedFile,
      handleFileChange,
      submitFile,
      downloadCsv,
      errorMessages,
      clearErrorMessages,
    };
  }
};
</script>

<style scoped>
.list-container {
  padding: 20px 20px 80px 20px;
  margin: auto;
}

.relative_humidity_matrix-item {
  border: 1px solid #ddd;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.relative_humidity_matrix-item:hover {
  background-color: #f5f5f5;
}

.table_box{
  max-width: 100%;
  height: 80vh;
  overflow-x: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
th, td {
  vertical-align: middle;
  padding: 4px;
  border: 1px solid #000;
  color: #000;
  font-size: 14px;
  text-align: center;
  white-space: nowrap;
}
th {
  background: #ccc;
}
td {
  background: #fff;
}
.sticky_row {
  position: sticky;
  top: 0;
  left: 0;
  background: none;
  border-left: none;
  border-right: none;
}
.sticky_row::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  background: #ccc;
  z-index: -1;
}
.sticky_col {
  position: sticky;
  background: none;
  border-top: none;
  border-bottom: none;
}
.sticky_col::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  background: #ccc;
  z-index: -1;
}
.first_col {
  top: 0;
  left: 0;
  text-align: left;
}
.first_col::before {
  top: 0;
  left: 0;
}
.second_col {
  top: 29px;
  left: 0;
}
.second_col::before {
  top: 0;
  left: 0;
}
.sticky_cross {
  position: sticky;
  top: 0;
  left: 0;
  background: none;
  border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: none;
  z-index: 1;
}
.sticky_cross::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  background: #ccc;
  z-index: -1;
}
</style>
